import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { TextField, IconButton, Stack } from "@mui/material";
import TopBar from "./TopBar";
import Divider from "@mui/material/Divider";
import CustomSnackbar from "../shared/snackbar";
import FormControl from "@mui/material/FormControl";
import ErrorOutlineSharpIcon from "@mui/icons-material/ErrorOutlineSharp";
import {
  InputLabel,
  OutlinedInput,
  Alert,
} from "@mui/material";
import axios from "axios";
import { useEffect } from "react";
import { ClipLoader } from "react-spinners";
import Confirmation from "../CustomerOnboarding/Confirmation";
import Banner from "../../assets/images/banner.svg";
import AMD from "../../assets/images/AMD.svg";
import GB from "../../assets/images/GB.svg";
import CPU from "../../assets/images/CPU.svg";
import Windows from "../../assets/images/Windows.svg";
import GBPS from "../../assets/images/GBPS.svg";
import ConnectLoader from "../../assets/images/connectloader.svg";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { styled } from "@mui/material/styles";
import { useSnackbar } from '../../components/snackbar';

function PaymentProceed() {
  const MainHeading = {
    typography: {
      fontFamily: "Roboto Flex",
    },
    // Other styles...
  };
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const CREATE_ORDER = `${SERVER_URI}/user/createOrder`;
  const FREE_PLAN = `${SERVER_URI}/freePlan`;
  const GET_USER = `${SERVER_URI}/user`;
  const VALIDATE_COUPON = `${SERVER_URI}/validateReferalCoupon`;
  const PAYMENT = `${SERVER_URI}/user/paymentSuccess`;
   const GET_SELECTEDPLAN =`${SERVER_URI}/getPlans/`

  const [isLoading, setIsLoading] = React.useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const [variant, setMessageVariant] = React.useState("");
  const [snackbaropen, setSnackbarOpen] = React.useState(false);

  const [message, setMessage] = React.useState("");

  const [selectedPaymentMode, setSelectedPaymentMode] =
    React.useState("razorpay");
  const [error, setError] = React.useState(null);
  const [code, setCode] = useState("");

  const [appliedCoupon, setAppliedCoupon] = useState("");
  const [isCodeValid, setIsCodeValid] = useState(false);
  const [isApplied, setIsApplied] = useState(false);
  const [isCouponValid, setIsCouponValid] = useState(false);
  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    mobileNumber: "",
  });
  const { enqueueSnackbar } = useSnackbar();

  const featureIcons = [AMD, GB, CPU, Windows, GBPS];

  useEffect(() => {
    const fetchPlans = async () => {
      const selplan = sessionStorage.getItem("selectedPlan");
      setIsLoading(true);
      try {
        const response = await axios.get(GET_SELECTEDPLAN + selplan);
        setSelectedPlan(response.data); // Assuming the response contains the selected plan
      } catch (error) {
        console.error("Error fetching plans:", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchPlans();
  }, []);
 
  const hitFreePlanApi = () => {
    setIsLoading(true);
    const token=localStorage.getItem("accessToken")
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    axios
      .post(FREE_PLAN, config,{
        withCredentials: true,
         
      })
      .then((response) => {
        setMessage("Free Trial Activated");
        setMessageVariant("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          setSnackbarOpen(false);
          setIsLoading(false);
          window.location.href = "/downloadwin"; // Redirect to downloadwin page after 2 seconds
        }, 2000);
      })
      .catch((error) => {
        setMessage("Failed to map VM: User is already mapped to a VM");
        setMessageVariant("error");
        setSnackbarOpen(true);
        setTimeout(function () {
          setSnackbarOpen(false);
          setIsLoading(false);
        }, 2000);
        console.error("Error hitting freePlan API:", error);
      });
  };
  const handleProceed = () => {
    if (selectedPlan?.planName === "Free Trial") {
      hitFreePlanApi();
    } else {
      createOrder();
    }
  };

  useEffect(() => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    axios
      .get(GET_USER, config, {
        withCredentials: true,
      })
      .then((response) => {
        const { name, email, mobileNumber } = response.data.user; // Adjust based on API response structure
        console.log(response.data.user.name);
        setUserDetails({ name, email, mobileNumber });
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, []);

  const createOrder = () => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let data = {
      paymentMode: selectedPaymentMode,
      planName: selectedPlan ? selectedPlan.planName : "No Plan Selected",
      couponCode: code
    };
    axios
      .post(CREATE_ORDER, data, config, {
        withCredentials: true,
      })
      .then((response) => {
        setSnackbarOpen(true);
        setIsLoading(true);
        if (response.data) {
          setMessage("Order Created");
          setMessageVariant("success");
          // setAddressList(response.data);
          // setSpinner(false);

          console.log(response.data);
          const { orderCreate } = response.data;
          console.log(orderCreate);
          const order_id = orderCreate?.id;
          console.log(order_id); // Output: "order_MFxDMogILBXShR"
          const receipt_id = orderCreate.receipt;
          console.log(receipt_id);
          const amount = orderCreate.amount;
          console.log("Amount:", amount);
          // setAmount(amount);
          const currency = orderCreate.currency;
          // Initialize Razorpay options
          let options = {
            // key: '0sx1nNcn0RMSqscNtc22Z5CY',
            // key: "rzp_test_YIUZXZBAfjhp12",
             key: "rzp_live_lrP0s1CxRNYZnj",
            // key: "rzp_live_lrP0s1CxRNYZnj",
            // amount: amount * 100, // Amount in paise or the smallest currency unit
            currency: currency,
            name: "Razor-Pay",
            description: "For testing purpose",
            order_id: order_id,
            receipt_id: receipt_id,
            handler: function (response) {
              const { razorpay_payment_id, razorpay_signature } = response;
              console.log("Payment ID:", razorpay_payment_id);
              console.log("Signature:", razorpay_signature);

              // Make a POST request to handle payment success with pdf
              axios
                .post(
                  PAYMENT,
                  {
                    razorpay_payment_id: razorpay_payment_id,
                    razorpay_order_id: order_id,
                    razorpay_signature: razorpay_signature,
                    receipt: receipt_id,
                    couponCode: code
                  },
                  {
                    withCredentials: true,
                  }
                )
                .then((response) => {
                  console.log("Payment success:", response.data);
                  setIsLoading(true);
                  setMessage(
                    "Payment successful. You will get a mail shortly !!!"
                  );
                  setMessageVariant("success");
                  setSnackbarOpen(true);
                  // setTimeout(async () => {

                  //     await MappingVmToDb();

                  // }, 2000);
                  setTimeout(function () {
                    setSnackbarOpen(false);
                    setIsLoading(false);
                    window.location.href = "/downloadwin";
                  }, 2000);
                })
                .catch((error) => {
                  setIsLoading(false);
                  console.error("Error handling payment success:", error);
                  // setShowBackdrop(false);
                });
            },
          };
          // Initialize and open Razorpay payment
          var razorpayInstance = new window.Razorpay(options);
          razorpayInstance.open();
        } else if (response.data.warning) {
          setIsLoading(false);
          setMessage(response.data.warning);
          setMessageVariant("warning");
        } else if (response.data.error) {
          setIsLoading(false);
          setMessage(response.data.error);
          setMessageVariant("error");
        }
      })
      .catch((err) => {
        console.log(err);
        // setShowBackdrop(false);
        setIsLoading(false);
        if (error.response && error.response.status === 401) {
          // Token is expired or invalid, open the dialog
          // setOpenexpireDialog(true);
        }
      });
    setTimeout(function () {
      setIsLoading(false);
      setSnackbarOpen(false);
    }, 5000);
  };


  const handleApplyCoupon = async () => {
    let token =localStorage.getItem("accessToken")
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      // Call the validateCoupon API
      const response = await axios.post(
        VALIDATE_COUPON,
        { couponCode: code },
        config,
        {
          withCredentials: true,
        }
      );
      console.log("RESPONSE DATA:", response.data);
      // Show success message
      enqueueSnackbar(response.data.message, { variant: 'success' });
      setMessageVariant("success");
      setIsCodeValid(true);
      setIsCouponValid(true);
      setIsApplied(true);
      setAppliedCoupon(code);
      const discountedPrice = selectedPlan?.amount * 0.5;
      const grandTotal = discountedPrice;

      // Calculate GST of 18%
      const gst = grandTotal * 0.18;

      // Final To Pay Amount
      const toPay = grandTotal + gst;
      // setToPayAmount(toPay);
    } catch (error) {
      console.error("Error applying coupon:", error);
      setIsApplied(true);
      setIsCouponValid(false);

      // Error handling for invalid coupon
      enqueueSnackbar(error.response.data.message, { variant: 'error' });
      setMessage("Invalid Coupon Code");
      setMessageVariant("error");
      setIsCodeValid(false);
      setAppliedCoupon("");
      setTimeout(() => {
        setSnackbarOpen(false);
        setIsApplied(false);
      }, 2000);
    }
  };

  return (
    <div>
      {/* <TopBar /> */}
      <Box
        sx={{
          padding: "50px",
          backgroundColor: "#fff",
          "@media (max-width: 600px)": { padding: "10px" },
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            marginTop: "10px",
            "@media (max-width: 791px)": {
              display: "flex",
              flexDirection: "column-reverse",
              // Modify the order of child elements on mobile
              "& > :nth-of-type(1)": {
                order: 3, // Plan Details first
              },
              "& > :nth-of-type(2)": {
                order: 1, // User Details second
              },
              "& > :nth-of-type(3)": {
                order: 2, // Amount third
              },
            },
          }}
        >
          <Grid item xs={12} md={8} spacing={2}>
            <Box
              sx={{
                padding: "20px",
                mb: 3,
                backgroundColor: "#F1F1F1",
                borderRadius: "10px",
                "@media (max-width: 600px)": { padding: "10px" },
              }}
            >
              <Typography
                sx={{
                  ...MainHeading.typography,
                  fontSize: "24px",
                  fontWeight: 600,
                  lineHeight: "18px",
                  letterSpacing: "0em",
                  textAlign: "left",
                  color: "#1E53E8",
                }}
              >
                Plan Details
              </Typography>
              <Typography
                sx={{
                  ...MainHeading.typography,
                  fontSize: 16,
                  fontWeight: 300,
                  lineHeight: "18px",
                  letterSpacing: "0em",
                  textAlign: "left",
                  color: "#131313",
                  marginTop: "10px",
                }}
              >
                {/* Our secure payment gateway ensures a smooth and hassle-free
                transaction. */}
              </Typography>

              {selectedPlan && (
                <Box
                  sx={{
                    padding: "20px",
                    backgroundColor: "#fff",
                    marginTop: "25px",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        marginTop: "10px",
                        ...MainHeading.typography,
                        fontSize: "24px",
                        fontWeight: 600,
                        lineHeight: "18px",
                        letterSpacing: "0em",
                        textAlign: "left",
                        color: "#1E53E8",
                      }}
                    >
                      {selectedPlan?.planName}
                    </Typography>
                    <ul style={{ paddingLeft: "10px", marginTop: "20px" }}>
                      {selectedPlan.features.map((feature, index) => (
                        <li
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            color: "var(--Tertiary---Black, #1F1F1F)",
                            fontFeatureSettings: "'liga' off, 'clig' off",
                            fontFamily: "Roboto Flex",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "40px", // 137.5%
                          }}
                        >
                          <img
                            src={featureIcons[index % featureIcons.length]} // Pick icon based on index
                            alt="icon"
                            style={{ width: "24px", marginRight: "10px" }}
                          />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </Box>
                </Box>
              )}
            </Box>
            {selectedPlan?.planName !== "Free Trial" && (
              <Box
                sx={{
                  padding: "20px",
                  backgroundColor: "#F1F1F1",
                  borderRadius: "10px",
                  "@media (max-width: 600px)": { padding: "10px" },
                }}
              >
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "24px",
                    fontWeight: 600,
                    lineHeight: "18px",
                    letterSpacing: "0em",
                    textAlign: "left",
                    color: "#1E53E8",
                  }}
                >
                  User Details
                </Typography>

                <Box
                  sx={{
                    padding: "20px",
                    backgroundColor: "#fff",
                    margin: "10px",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: "20px",
                    alignItems: "center",
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <PersonIcon sx={{ color: "#1E53E8" }} />
                        <Typography>{userDetails.name || "N/A"}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <EmailIcon sx={{ color: "#1E53E8" }} />
                        <Typography>{userDetails.email || "N/A"}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <PhoneIcon sx={{ color: "#1E53E8" }} />
                        <Typography>
                          {userDetails.mobileNumber || "N/A"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            )}
          </Grid>

          {/* ONLY FOR FREE TRIAL SCREEN */}
          {selectedPlan?.planName === "Free Trial" && (
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  padding: "20px",
                  backgroundColor: "#F1F1F1",
                  borderRadius: "10px",
                  "@media (max-width: 600px)": { padding: "10px" },
                }}
              >
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "24px",
                    fontWeight: 600,
                    lineHeight: "18px",
                    letterSpacing: "0em",
                    textAlign: "left",
                    color: "#1E53E8",
                  }}
                >
                  User Details
                </Typography>

                <Box
                  sx={{
                    padding: "20px",
                    backgroundColor: "#fff",
                    margin: "10px",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: "20px",
                    alignItems: "center",
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <PersonIcon sx={{ color: "#1E53E8" }} />
                        <Typography>{userDetails.name || "N/A"}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          overflow: "hidden",
                          // maxWidth:"100%",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <EmailIcon sx={{ color: "#1E53E8" }} />
                        <Typography>{userDetails.email || "N/A"}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                         
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <PhoneIcon sx={{ color: "#1E53E8" }} />
                        <Typography>
                          {userDetails.mobileNumber || "N/A"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>

              {/* Try It Text */}
              <Box
                sx={{
                  padding: "20px",
                  backgroundColor: "#F1F1F1",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "20px",
                  "@media (max-width: 600px)": { padding: "10px" },
                }}
              >
                {/* Icon */}
                <ErrorOutlineSharpIcon
                  sx={{
                    color: "#1E53E8",
                    fontSize: "36px",
                    marginRight: "10px",
                  }}
                />

                {/* Text */}
                <Typography
                  variant="body1"
                  sx={{ color: "#000", fontFamily: "Roboto Flex" }}
                >
                  Enjoy a free 3-hour free trial of MegaConnect Cloud PC after your first login
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "block",
                  "@media (max-width: 791px)": { display: "none" },
                }}
              >
                <Button
                  // onClick={checkout}

                  sx={{
                    fontFamily: "Roboto Flex",
                    width: "100%",
                    height: "48px",
                    textAlign: "center",
                    marginTop: "30px",
                    backgroundColor: "#C7F760",
                    boxShadow: "none",
                    color: "#1E53E8",
                    textTransform: "none",
                    fontWeight: 900,
                    "&:hover": { backgroundColor: "#1E53E8", color: "#C7F760" },
                  }}
                  variant="contained"
                  onClick={handleProceed}
                >
                  Proceed
                </Button>
              </Box>
            </Grid>
          )}
          {/* FOR ALL PLANS EXCEPT FREE TRIAL  */}
          {selectedPlan?.planName !== "Free Trial" && (
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  backgroundColor: "#F1F1F1",
                  padding: "20px",
                  borderRadius: "10px",
                }}
              >
                <img src={Banner} alt="" />
                <br />
                <br />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItem: "center",
                    marginBlock: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      ...MainHeading.typography,
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "left",
                    }}
                  >
                    <li>{selectedPlan?.planName}</li>
                  </Typography>
                  <Typography
                    sx={{
                      ...MainHeading.typography,
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "left",
                    }}
                  >
                    ₹{selectedPlan?.amount}
                  </Typography>
                </div>

                {/* Show Discount if Coupon is Applied */}
                {isCouponValid && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBlock: "10px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 400,
                        textAlign: "left",
                      }}
                    >
                      <li>Discount (50%)</li>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 400,
                        textAlign: "left",
                      }}
                    >
                      -
                      {(() => {
                        const priceStr = (selectedPlan?.amount && typeof selectedPlan.amount === 'number' ? selectedPlan.amount.toString() : '0') || '0'; // Convert to string or use '0' if invalid
                        const price = parseFloat(priceStr.replace(/₹|,/g, "").trim()) || 0; // Parse the plan price after cleaning
                      
                        const discount = price * 0.5; // Calculate 50% discount
                        const total = price - discount; // Subtract discount from original price
                        return `₹${total.toFixed(1)}`; // Return formatted total
                      })()}
                    </Typography>
                  </div>
                )}

                <Divider />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBlock: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: 600,
                      textAlign: "left",
                    }}
                  >
                    Grand Total
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: 600,
                      textAlign: "left",
                      color: "#1E53E8",
                    }}
                  >
                    {(() => {
                       const priceStr = (selectedPlan?.amount && typeof selectedPlan.amount === 'number' ? selectedPlan.amount.toString() : '0') || '0'; // Convert to string or use '0' if invalid
                       const price = parseFloat(priceStr.replace(/₹|,/g, "").trim()) || 0; // Parse the plan price after cleaning
                     
                      const discount = price * 0.5; // Calculate 50% discount
                      const grandTotal = price - discount; // Calculate grand total after discount

                      // Check if coupon code is valid
                      if (isCouponValid) {
                        return `₹${grandTotal.toFixed(1)}`; // Show grand total after discount
                      } else {
                        return `₹${price.toFixed(1)}`; // Show original price if no coupon is applied
                      }
                    })()}
                  </Typography>
                </div>

                {/* GST Calculation */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBlock: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 400,
                      textAlign: "left",
                    }}
                  >
                    <li>GST 18%</li>
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 400,
                      textAlign: "left",
                    }}
                  >
                    {(() => {
                        const priceStr = (selectedPlan?.amount && typeof selectedPlan.amount === 'number' ? selectedPlan.amount.toString() : '0') || '0'; // Convert to string or use '0' if invalid
                        const price = parseFloat(priceStr.replace(/₹|,/g, "").trim()) || 0; // Parse the plan price after cleaning
                      
                      const discount = price * 0.5; // Calculate 50% discount
                      const grandTotal = price - discount; // Calculate grand total after discount
                      const gst = isCouponValid
                        ? grandTotal * 0.18
                        : price * 0.18; // Calculate GST based on validity of coupon
                      return `₹${gst.toFixed(2)}`; // Return formatted GST amount
                    })()}
                  </Typography>
                </div>

                {/* To Pay */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBlock: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: 600,
                      textAlign: "left",
                    }}
                  >
                    To Pay
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: 600,
                      textAlign: "left",
                      color: "#1E53E8",
                    }}
                  >
                    {(() => {
                        const priceStr = (selectedPlan?.amount && typeof selectedPlan.amount === 'number' ? selectedPlan.amount.toString() : '0') || '0'; // Convert to string or use '0' if invalid
                        const price = parseFloat(priceStr.replace(/₹|,/g, "").trim()) || 0; // Parse the plan price after cleaning
                      
                      const discount = price * 0.5; // 50% discount
                      const grandTotal = price - discount; // Calculate grand total after discount
                      const gst = grandTotal * 0.18; // Calculate 18% GST on grand total
                      const totalToPay = grandTotal + gst; // Total to pay (grand total + GST)

                      // Check if coupon code is valid
                      if (isCouponValid) {
                        return `₹${totalToPay.toFixed(2)}`; // Show total after discount and GST
                      } else {
                        const originalGst = price * 0.18; // Calculate GST on original price
                        const originalTotalToPay = price + originalGst; // Total to pay (original price + original GST)
                        return `₹${originalTotalToPay.toFixed(2)}`; // Show original price with GST
                      }
                    })()}
                  </Typography>
                </div>
                {/* MOBILE VIEW BUTTON */}

                <Box
                  sx={{
                    display: "none",
                    "@media (max-width: 791px)": { display: "block" },
                  }}
                >
                  <Box
                    sx={{
                      display: "block",
                      padding: "20px",
                      top: "20px",
                      backgroundColor: "#F5F5F5", // Light background for coupon box
                      borderRadius: "8px", // Rounded corners
                      position: "relative",
                    }}
                  >
                    <Stack direction="row" spacing={1}>
                      <FormControl
                        variant="outlined"
                        size="small"
                        sx={{
                          flex: 1, // Take all available space
                          // marginRight: "10px", // Add space between input and button
                          borderRadius: "20px",
                          // "@media (max-width: 791px)": { width: "330px" },
                        }}
                      >
                        <InputLabel htmlFor="outlined-adornment-coupon-code">
                          Apply referral code
                        </InputLabel>
                        <OutlinedInput // Use OutlinedInput instead of FilledInput
                          id="outlined-adornment-password" // Update the ID
                          type="text"
                          label="Coupon Code"
                          disabled={isApplied}
                          value={code}
                          onChange={(e) => {
                            console.log("Code changed to:", e.target.value);
                            setCode(e.target.value);
                            setIsApplied(false);
                            setIsCouponValid(false);
                            setIsCodeValid(false);
                          }}
                          sx={{
                            backgroundColor: "white", // Set background color to white
                            border: "none", // Remove border
                            "& fieldset": { border: "none" }, // Remove the fieldset border
                            "&:hover fieldset": { border: "none" }, // Remove border on hover
                            "&.Mui-focused fieldset": { border: "none" }, // Remove border when focused
                          }}
                        />

                        <div style={{ marginTop: "10px" }}>
                          {isApplied && // Display alert only if the code is applied
                            (isCodeValid ? (
                              <Alert severity="success">
                                Coupon Code Applied!
                              </Alert>
                            ) : (
                              <Alert severity="error">
                                Invalid Coupon Code
                              </Alert>
                            ))}
                        </div>
                      </FormControl>

                      <Button
                        sx={{
                          height: "40px",
                          marginBottom: "12px",
                          backgroundColor: isApplied ? "#C7F760" : "#1E53E8",
                          color: isApplied ? "#1E53E8" : "#C7F760",
                          fontWeight: 900,
                          "&:hover": {
                            backgroundColor: isApplied ? "#C7F760" : "#1E53E8",
                            color: isApplied ? "#1E53E8" : "#C7F760",
                          },
                        }}
                        onClick={handleApplyCoupon}
                        variant="contained"
                        disabled={isApplied}
                      >
                        {isApplied ? "Applied" : "Apply"}
                      </Button>
                    </Stack>
                  </Box>
                </Box>
              </Box>

              {/* Website View */}
              <Box
                sx={{
                  display: "block",
                  padding: "20px",
                  top: "20px",
                  backgroundColor: "#F5F5F5", // Light background for coupon box
                  borderRadius: "8px", // Rounded corners
                  position: "relative",
                  "@media (max-width: 791px)": { display: "none" },
                }}
              >
                <Stack direction="row" spacing={1}>
                  <FormControl
                    variant="outlined"
                    size="small"
                    sx={{
                      flex: 1, // Take all available space
                      // marginRight: "10px", // Add space between input and button
                      borderRadius: "20px",
                      // "@media (max-width: 791px)": { width: "330px" },
                    }}
                  >
                    <InputLabel htmlFor="outlined-adornment-coupon-code">
                      Apply referral code
                    </InputLabel>
                    <OutlinedInput // Use OutlinedInput instead of FilledInput
                      id="outlined-adornment-password" // Update the ID
                      type="text"
                      label="Coupon Code"
                      disabled={isApplied}
                      value={code}
                      onChange={(e) => {
                        console.log("Code changed to:", e.target.value);
                        setCode(e.target.value);
                        setIsApplied(false);
                        setIsCouponValid(false);
                        setIsCodeValid(false);
                      }}
                      error={!isCodeValid && !isApplied}
                      sx={{
                        backgroundColor: "white", // Set background color to white
                        border: "none", // Remove border
                        "& fieldset": { border: "none" }, // Remove the fieldset border
                        "&:hover fieldset": { border: "none" }, // Remove border on hover
                        "&.Mui-focused fieldset": { border: "none" }, // Remove border when focused
                      }}
                    />
                    <div style={{ marginTop: "10px" }}>
                      {isApplied && // Display alert only if the code is applied
                        (isCodeValid ? (
                          <Alert severity="success">Coupon Code Applied!</Alert>
                        ) : (
                          <Alert severity="error">Invalid Coupon Code</Alert>
                        ))}
                    </div>
                  </FormControl>

                  <Button
                    sx={{
                      height: "40px",
                      marginBottom: "12px",
                      backgroundColor: isApplied ? "#C7F760" : "#1E53E8",
                      color: isApplied ? "#1E53E8" : "#C7F760",
                      fontWeight: 900,
                      "&:hover": {
                        backgroundColor: isApplied ? "#C7F760" : "#1E53E8",
                        color: isApplied ? "#1E53E8" : "#C7F760",
                      },
                    }}
                    onClick={handleApplyCoupon}
                    variant="contained"
                    disabled={isApplied}
                  >
                    {isApplied ? "Applied" : "Apply"}
                  </Button>
                </Stack>
              </Box>

              <Box
                sx={{
                  display: "block",
                  "@media (max-width: 791px)": { display: "none" },
                }}
              >
                <Button
                  // onClick={checkout}

                  sx={{
                    fontFamily: "Roboto Flex",
                    width: "100%",
                    height: "48px",
                    textAlign: "center",
                    marginTop: "30px",
                    backgroundColor: "#C7F760",
                    boxShadow: "none",
                    color: "#1E53E8",
                    textTransform: "none",
                    fontWeight: 900,
                    "&:hover": { backgroundColor: "#1E53E8", color: "#C7F760" },
                  }}
                  variant="contained"
                  onClick={handleProceed}
                >
                  Proceed
                </Button>
              </Box>
            </Grid>
          )}
        </Grid>
        <Box
          sx={{
            display: "none",
            "@media (max-width: 791px)": { display: "block" },
          }}
        >
          <Button
            onClick={handleProceed}
            sx={{
              fontFamily: "Roboto Flex",
              width: "100%",
              textAlign: "center",
              marginTop: "30px",
              backgroundColor: "#C7F760",
              color: "#1E53E8",
              textTransform: "none",
              ontWeight: 900,
              "&:hover": { backgroundColor: "#1E53E8", color: "#C7F760" },
            }}
            variant="contained"
          >
            Proceed
          </Button>
        </Box>
      </Box>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.5)", // Adjust the opacity as needed
            backdropFilter: "blur(1px)",
            zIndex: 9999, // Ensure the overlay is above other content
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            {/* <ClipLoader color={"#374ad7"} size={50} /> */}
            <img
              src={ConnectLoader}
              alt=""
              style={{ color: "#374ad7", fontSize: "50%" }}
            />
          </Box>
        </div>
      )}
      <CustomSnackbar message={message} variant={variant} open={snackbaropen} />
      <div style={{ display: "none" }}>
        <Confirmation
        //   ldapIntegration={LdapIntegration}
        //   mappingVmToDb={MappingVmToDb}
        />
      </div>
    </div>
  );
}

export default PaymentProceed;
